/*
* author: liujianhong
* mail: 64617842@qq.com
* */
import { ajax } from '@/utils/request';

const api = {
    /***** @借款申请 *****/
    // 借款申请-列表统计
    borrowingCount(data:any){
        return ajax({
            method: 'get',
            url: `borrowing-mgt/inquiry-sum`,
            data
        });
    },
    // 借款申请-分页
    borrowingList(data:any){
        return ajax({
            method: 'get',
            url: `borrowing-mgt/borrowing`,
            data
        });
    },
    // 借款申请-新增
    borrowingAdd(data:any){
        return ajax({
            method: 'post',
            url: `borrowing-mgt/borrowing`,
            data
        });
    },
    // 借款申请-修改
    borrowingUpdate(id:any,data:any){
        return ajax({
            method: 'put',
            url: `borrowing-mgt/borrowing/${id}`,
            data
        });
    },
    // 借款申请-详情
    borrowingDetail(id:any){
        return ajax({
            method: 'get',
            url: `borrowing-mgt/borrowing/${id}`
        });
    },
    // 借款申请-退回
    borrowingBack(id:any){
        return ajax({
            method: 'put',
            url: `borrowing-mgt/${id}/back`,
        });
    },
    // 借款申请-作废
    borrowingVoid(id:any){
        return ajax({
            method: 'put',
            url: `borrowing-mgt/${id}/cancel`,
        });
    },
    // 借款申请-确认
    borrowingConfirm(id:any){
        return ajax({
            method: 'put',
            url: `borrowing-mgt/${id}/confirm`,
        });
    },
    // 借款申请-审核不通过
    borrowingApporveRefuse(data:any){
        return ajax({
            method: 'put',
            url: `borrowing-mgt/${data.id}/reject`,
            data
        });
    },
    // 借款申请-导出列表
    borrowingListExport(data:any){
        return ajax({
            method: 'get',
            url: `borrowing-mgt/export`,
            type:'blob',
            data
        });
    },
    // 借款申请-导出pdf
    borrowingExportPdf(id:any){
        return ajax({
            method: 'get',
            url: `borrowing-mgt/export/${id}`,
            type:'blob'
        });
    },

    /***** @报销申请 *****/
    // 借款申请-列表统计
    reimbursementCount(data:any){
        return ajax({
            method: 'get',
            url: `reimbursement-mgt/reimbursement-sum`,
            data
        });
    },
    // 借款申请-分页
    reimbursementList(data:any){
        return ajax({
            method: 'get',
            url: `reimbursement-mgt/reimbursement`,
            data
        });
    },
    // 借款申请-新增
    reimbursementAdd(data:any){
        return ajax({
            method: 'post',
            url: `reimbursement-mgt/reimbursement`,
            data
        });
    },
    // 借款申请-修改
    reimbursementUpdate(id:any,data:any){
        return ajax({
            method: 'put',
            url: `reimbursement-mgt/reimbursement/${id}`,
            data
        });
    },
    // 借款申请-详情
    reimbursementDetail(id:any){
        return ajax({
            method: 'get',
            url: `reimbursement-mgt/reimbursement/${id}`
        });
    },
    // 借款申请-退回
    reimbursementBack(id:any){
        return ajax({
            method: 'put',
            url: `reimbursement-mgt/${id}/back`,
        });
    },
    // 借款申请-作废
    reimbursementVoid(id:any){
        return ajax({
            method: 'put',
            url: `reimbursement-mgt/${id}/cancel`,
        });
    },
    // 借款申请-审核不通过
    reimbursementApporveRefuse(data:any){
        return ajax({
            method: 'put',
            url: `reimbursement-mgt/${data.id}/reject`,
            data
        });
    },
    // 借款申请-导出列表
    reimbursementListExport(data:any){
        return ajax({
            method: 'get',
            url: `reimbursement-mgt/export`,
            type:'blob',
            data
        });
    },
    // 报销申请-借款冲销单查询
    reimbursementOffsetBorrow(data:any){
        return ajax({
            method: 'get',
            url: `reimbursement-mgt/reimbursement/offset/borrowings`,
            data
        });
    },
    // 借款申请-导出pdf
    reimbursementExportPdf(id:any){
        return ajax({
            method: 'get',
            url: `reimbursement-mgt/export/${id}`,
            type: 'blob'
        });
    },

    /***** @材料询价 *****/
    // 材料询价-列表统计
    inquiryCount(data:any){
        return ajax({
            method: 'get',
            url: `inquiry-mgt/inquiry-sum`,
            data
        });
    },
    // 材料询价-分页
    inquiryList(data:any){
        return ajax({
            method: 'get',
            url: `inquiry-mgt/inquiry`,
            data
        });
    },
    // 材料询价-新增
    inquiryAdd(data:any){
        return ajax({
            method: 'post',
            url: `inquiry-mgt/inquiry`,
            data
        });
    },
    // 材料询价-修改
    inquiryUpdate(id:any,data:any){
        return ajax({
            method: 'put',
            url: `inquiry-mgt/inquiry/${id}`,
            data
        });
    },
    // 材料询价-详情
    inquiryDetail(id:any){
        return ajax({
            method: 'get',
            url: `inquiry-mgt/inquiry/${id}`
        });
    },
    // 材料询价-退回
    inquiryBack(id:any){
        return ajax({
            method: 'put',
            url: `inquiry-mgt/${id}/back`,
        });
    },
    // 材料询价-作废
    inquiryVoid(id:any){
        return ajax({
            method: 'put',
            url: `inquiry-mgt/${id}/cancel`,
        });
    },
    // 材料询价-审核不通过
    inquiryApporveRefuse(data:any){
        return ajax({
            method: 'put',
            url: `inquiry-mgt/${data.id}/reject`,
            data
        });
    },
    // 材料询价-导出列表
    inquiryListExport(data:any){
        return ajax({
            method: 'get',
            url: `inquiry-mgt/export`,
            type:'blob',
            data
        });
    },
    // 材料询价-导出pdf
    inquiryExportPdf(id:any){
        return ajax({
            method: 'get',
            url: `inquiry-mgt/export/${id}`,
            type: 'blob'
        });
    },
    // 工程任务单导入模板
    labourTemplateExport(){
        return ajax({
            method: 'get',
            url: `contract-apply/template-labour-details`,
            type: 'blob'
        });
    },
    // 材料合同材料信息导入模板
    getMaterialContractTemplate(){
        return ajax({
            method: 'get',
            url: `contract-apply/template-material-details`,
            type: 'blob'
        });
    },
    // 双包合同材料明细导入模板
    getDoubleContractTemplate(){
        return ajax({
            method: 'get',
            url: `contract-apply/template-double-details`,
            type: 'blob'
        });
    },
    //甲方材料结算申请-列表
    firstMaterialSettleList(data:any){
        return ajax({
            method: 'get',
            url: `fist-material-settlement-mgt/settlement`,
            data: data
        });
    },
    //甲方材料结算申请-新增
    firstMaterialSettleAdd(data:any){
        return ajax({
            method: 'post',
            url: `fist-material-settlement-mgt/settlement`,
            data: data
        });
    },
    //甲方材料结算申请-编辑
    firstMaterialSettleUpdate(data:any){
        return ajax({
            method: 'put',
            url: `fist-material-settlement-mgt/settlement/${data.id}`,
            data: data
        });
    },
    //甲方材料结算申请-详情
    firstMaterialSettleDetail(id:any){
        return ajax({
            method: 'get',
            url: `fist-material-settlement-mgt/settlement/${id}`,
        });
    },
    //甲方材料结算申请-退回发起人
    firstMaterialSettleBackToInitiator(data:any){
        return ajax({
            method: 'put',
            url: `fist-material-settlement-mgt/back-start/${data.id}`,
            data: data
        });
    },
    //甲方材料结算申请-撤销
    firstMaterialSettleRevocation(id:any){
        return ajax({
            method: 'put',
            url: `fist-material-settlement-mgt/undo/${id}`,
        });
    },
    //甲方材料结算申请-删除
    firstMaterialSettleDele(id:any){
        return ajax({
            method: 'delete',
            url: `fist-material-settlement-mgt/${id}`,
        });
    },
    //甲方材料结算申请-统计
    firstMaterialSettleCount(data:any){
        return ajax({
            method: 'get',
            url: `fist-material-settlement-mgt/settlement-sum`,
            data: data
        });
    },
    //甲方材料结算申请-退回
    firstMaterialSettleBack(id:any){
        return ajax({
            method: 'put',
            url: `fist-material-settlement-mgt/${id}/back`,
        });
    },
    //甲方材料结算申请-作废
    firstMaterialSettleVoid(id:any){
        return ajax({
            method: 'put',
            url: `fist-material-settlement-mgt/${id}/cancel`,
        });
    },
    //甲方材料结算申请-审核不通过
    firstMaterialSettleArroveNotPassed(data:any){
        return ajax({
            method: 'put',
            url: `fist-material-settlement-mgt/${data.id}/reject`,
            data: data
        });
    },
    //甲方材料结算申请-导出列表
    firstMaterialSettleExportList(data:any){
        return ajax({
            method: 'get',
            url: `fist-material-settlement-mgt/export`,
            data: data,
            type: 'blob'
        });
    },
    //甲方材料结算申请-导出pdf
    firstMaterialSettleExportPdf(id:any){
        return ajax({
            method: 'get',
            url: `fist-material-settlement-mgt/export/${id}`,
            type: 'blob'
        });
    },
};

export default api;
